// store/scoreboard/scoreboardSelectors.js

export const selectScoreboardData = (key) => (state) => {
  return state.scoreboard?.boards[key];
};

export const selectClassesList = (state) => {
  return state.scoreboard?.boards['classes'];
};

export const selectAllHousesData = (boardName, houses) => (state) => {
  const data = {};
  houses?.forEach(house => {
    const houseKey = `${boardName}_${house.id}`;
    data[house.id] = state.scoreboard?.boards?.[houseKey];
  });
  return data;
};